<template>
  <div>
    <b-container class="mt-5 mb-5">
      <h1 class="fs-4 font-weight-bold mb-4">Nieuw evenement</h1>
      <Stepper :step="step" :steps="steps" />

      <template v-if="step == 1">
        <ValidationObserver ref="form1" slim>
          <EventDetails :form="form" />
          <EventDates :form="form" />
          <EventLocation :form="form" />
          <EventSaleDate :form="form" />
          <EventMarketing :form="form" />
        </ValidationObserver>
      </template>

      <template v-if="step == 2">
        <ValidationObserver ref="form2" slim>
          <b-card v-for="(ticket, key) in form.tickets" :key="key" class="mb-3">
            <h4 class="fs-5 font-weight-bold mb-3">Ticket {{ key + 1 }}</h4>
            <div class="remove-slot">
              <b-button
                @click="removeTicket(ticket)"
                variant="outline-primary"
                class="float-right"
              >
                <font-awesome-icon icon="fa-solid fa-remove ml-2" />
              </b-button>
            </div>
            <EventTicket :event="form" :ticket="ticket" />
          </b-card>

          <div class="text-center">
            <b-button variant="primary" @click="addTicket()">
              Ticket toevoegen
              <font-awesome-icon icon="fa-solid fa-plus ml-2" />
            </b-button>
          </div>
        </ValidationObserver>
      </template>

      <template v-if="step == 3">
        <ValidationObserver ref="form3" slim>
          <EventPersonal :form="form" />
        </ValidationObserver>
      </template>

      <template v-if="step == 4">
        <ValidationObserver ref="form4" slim>
          <EventOptions :form="form" />
        </ValidationObserver>
      </template>

      <div class="clearfix">
        <b-button
          v-if="step > 1"
          @click="prevStep"
          variant="outline-primary"
          class="float-left"
        >
          <font-awesome-icon icon="fa-solid fa-chevron-left" />
          Vorige
        </b-button>

        <b-button
          v-if="step < 4"
          @click="nextStep"
          variant="primary"
          class="float-right"
        >
          Volgende
          <font-awesome-icon icon="fa-solid fa-chevron-right" />
        </b-button>

        <b-button
          v-if="step == 4"
          @click="submitStep"
          variant="primary"
          class="float-right"
        >
          Opslaan
          <font-awesome-icon icon="fa-solid fa-chevron-right" />
        </b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import Stepper from "@/components/Stepper";

import EventDetails from "@/components/event/EventDetails.vue";
import EventLocation from "@/components/event/EventLocation.vue";
import EventSaleDate from "@/components/event/EventSaleDate.vue";
import EventDates from "@/components/event/EventDates.vue";
import EventOptions from "@/components/event/EventOptions.vue";
import EventPersonal from "@/components/event/EventPersonal.vue";
import EventMarketing from "@/components/event/EventMarketing.vue";
import EventTicket from "@/components/event/EventTicket.vue";

export default {
  metaInfo: {
    title: "Nieuw evenement",
  },
  components: {
    ValidationObserver,
    Stepper,
    EventDetails,
    EventLocation,
    EventSaleDate,
    EventDates,
    EventOptions,
    EventPersonal,
    EventMarketing,
    EventTicket,
  },
  data() {
    return {
      step: 1,
      steps: [
        { icon: "fa-calendar", title: "Evenement" },
        { icon: "fa-ticket", title: "Tickets" },
        { icon: "fa-user", title: "Persoonsgegevens" },
        { icon: "fa-cog", title: "Extra opties" },
      ],
      form: {
        name: null,
        description: null,
        location_id: null,
        type: "single",
        start_sale_at: null,
        slots: [],
        tickets: [],
        extra_details: [],
        extra_details_required: [],
        is_personal_ticket: false,
        personal_details_required: [],
        minimal_age: null,
        is_customer_transaction_fee: false,
        is_customer_ticket_fee: false,
        customer_ticket_fee: null,
        is_invoicing: false,
        invoicing_vat_rate: 21,
        is_accept_donations: false,
        donation_description: null,
        primary_category: null,
        secondary_category: null,
        tags: [],
        is_highlighted: false,
      },
    };
  },
  computed: {},
  methods: {
    removeTicket: function (ticket) {
      var index = this.form.tickets.indexOf(ticket);
      if (index !== -1) {
        this.form.tickets.splice(index, 1);
      }
    },
    addTicket: function () {
      this.form.tickets.push({
        type: null,
        name: null,
        description: null,
        price: null,
        amount_available: null,
        extra_information: null,
        header_image: null,
        is_custom_sell_date: false,
        start_sale_at_date: null,
        start_sale_at_time: null,
        end_sale_at_date: null,
        end_sale_at_time: null,
        is_multiday_ticket: false,
        is_custom_valid_date: false,
        start_valid_at_date: null,
        start_valid_at_time: null,
        end_valid_at_date: null,
        end_valid_at_time: null,
      });
    },
    prevStep: function () {
      this.step--;

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    async nextStep() {
      let check = await this.$refs["form" + this.step].validate();

      if (!check) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        return;
      }

      this.step++;

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    submitStep: function () {
      this.$axios
        .post("https://api.tixgo.nl/events", this.form)
        .then((response) => {
          response;
          this.$router.push("/manage/events");
        });
    },
  },
  created() {},
};
</script>

<style>
.type-toggle label {
  margin-left: 10px;
  vertical-align: middle;
}
.type-toggle .custom-radio {
  border: 1px solid #eee;
  border-radius: 0.5rem;
  margin-bottom: 15px;
  padding: 15px;
}
.remove-slot {
  position: absolute;
  right: 15px;
  top: 15px;
}
.tab-body {
  border: 1px solid #eee;
}
</style>
